/* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
:host {
    display: block;
    position: relative;
    overflow: hidden;

    > .scroll-btn {
        position: absolute;
        top: 0;
        border-width: 0;
        z-index: 1;
        padding: 0;
        color: $color-grey-01-dark;
        background-color: transparent;

        &.--hide {
            display: none;
        }

        &--left {
            left: -9px;

            &::before {
                content: '';
                pointer-events: none;
                position: absolute;
                top: 0;
                left: 18px;
                width: 50px;
                height: 100%;
                background: linear-gradient(to left, rgba($color-white, 0) 0%, rgba($color-white, 1) 80%);
            }
        }

        &--right {
            right: -9px;

            &::before {
                content: '';
                pointer-events: none;
                position: absolute;
                top: 0;
                right: 18px;
                width: 50px;
                height: 100%;
                background: linear-gradient(to right, rgba($color-white, 0) 0%, rgba($color-white, 1) 80%);
            }
        }

        .svg {
            background-color: $color-white;
            display: block;
        }
    }

    .tabs-nav {
        display: flex;
        gap: 20px;
        position: relative;
        scroll-behavior: smooth;
        margin: 0;
        padding: 0;
        overflow-x: scroll;
        white-space: nowrap;
        user-select: none;
        -ms-overflow-style: none;
        scrollbar-width: none;
        scroll-snap-type: inline mandatory;

        &::-webkit-scrollbar {
            display: none;
        }
    }
}
